import React from "react";

function Title(props) {
  return (
    <div>
      <div className="container">
        <div className="row justify-content-center" >
          <div className="col-md-12 col-lg-11">
            <h4 className="mbr-section-title mbr-fonts-style mb-4 mt-0 display-2">
              <strong className="heading-border">
                {props.name}
              </strong>
            </h4>
            <p className="mbr-text mbr-fonts-style display-7 text-justify">
              Welcome to the future of healthcare management! ITSC Hospital
              Management Information System is the ultimate game-changer for
              healthcare institutions of all sizes, from small clinics to large
              hospitals.
            </p>
            <p className="mbr-text mbr-fonts-style display-7 text-justify">
              Our versatile software seamlessly integrates Clinical, Financial,
              and Administrative Management, revolutionizing the way medical
              enterprises operate across multiple locations.
            </p>
            <p className="mbr-text mbr-fonts-style display-7 text-justify">
              Experience the power of ITSC - HMIS, a comprehensive modular
              package designed to streamline healthcare practices and empower
              users with instant access to critical information.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Title;
